import { getFood } from './foodDatabase';
import type { FoodInput, FoodTestId, FoodTestOutcome, OutcomeCategory } from './types';

export function resolveFood(food: FoodInput) {
  return typeof food === 'string' ? getFood(food) : food;
}

export function failedOutcome(test: FoodTestId, message: string): FoodTestOutcome {
  return {
    test,
    category: 'failed',
    observation: message,
    colour: '#7a2430',
    colourName: 'procedure failure',
    precipitate: false,
    emulsion: false,
    reasoning: message,
    warnings: [message],
  };
}

export function concentrationCategory(level: number): OutcomeCategory {
  if (level <= 0) return 'negative';
  if (level < 0.3) return 'trace';
  if (level < 0.5) return 'weak-positive';
  if (level < 0.8) return 'positive';
  return 'strong-positive';
}